import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileBarChart2, ChevronDown, ChevronUp } from "lucide-react";

export function ReportBody({ data }) {
  return (
    <div className="mt-3 text-sm">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {[["Demandes", data.requests], ["Confirmées", data.confirmed], ["Séances réglées", data.paid_sessions], ["Revenus", `${data.revenue.toFixed(2)} €`], ["Remplissage", `${data.fill_rate} %`], ["Créneaux publiés", data.slots], ["Annulées", data.cancelled], ["Refusées", data.rejected]].map(([l, v]) => (
          <div key={l} className="rounded-xl bg-slate-50 border border-slate-100 p-2"><div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div><div className="font-bold text-slate-900">{v}</div></div>
        ))}
      </div>
      {data.best_hours?.length > 0 && <div className="mt-2 text-xs text-slate-600">Meilleurs horaires : {data.best_hours.map((h) => `${h.hour}h (${h.count})`).join(", ")}</div>}
      <table className="mt-3 w-full text-xs">
        <thead className="text-slate-500 text-left uppercase tracking-wider"><tr><th className="py-1">Salle</th><th>Confirmées</th><th>Revenus</th><th>Remplissage</th><th>Note</th><th>Favoris</th><th>Coachs approuvés</th></tr></thead>
        <tbody>{data.per_room.map((r) => (
          <tr key={r.id} className="border-t border-slate-100"><td className="py-1.5 font-semibold text-slate-900">{r.name}</td><td>{r.confirmed}</td><td className="text-emerald-700 font-semibold">{r.revenue.toFixed(2)} €</td><td>{r.fill_rate} %</td><td>{r.rating_avg ?? "—"} ({r.reviews})</td><td>{r.favorites}</td><td>{r.approved_coaches}</td></tr>
        ))}</tbody>
      </table>
      {data.top_coaches?.length > 0 && <div className="mt-2 text-xs text-slate-600">Coachs les plus actifs : {data.top_coaches.map((c) => `${c.name} (${c.sessions})`).join(", ")}</div>}
    </div>
  );
}

export default function QuarterlyReports() {
  const [reports, setReports] = useState([]);
  const [current, setCurrent] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/manager/reports").then((r) => setReports(r.data)).catch(() => {});
    api.get("/manager/reports/current").then((r) => setCurrent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mt-8 sc-card" data-testid="quarterly-reports">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><FileBarChart2 className="w-5 h-5 text-indigo-500" /> Bilans trimestriels</h2>
      <p className="text-sm text-slate-600 mt-1">Un bilan complet par trimestre, envoyé par email et archivé ici.</p>
      {current && (
        <div className="mt-3 rounded-xl border border-indigo-200 bg-indigo-50/40 p-3" data-testid="report-current">
          <div className="font-semibold text-indigo-900">{current.label}</div>
          <ReportBody data={current.data} />
        </div>
      )}
      <div className="mt-3 space-y-2">
        {reports.map((r) => (
          <div key={r.id} className="rounded-xl border border-slate-200 p-3" data-testid={`report-${r.id}`}>
            <button className="w-full flex items-center justify-between text-left" onClick={() => setOpen(open === r.id ? null : r.id)} data-testid={`report-toggle-${r.id}`}>
              <div><span className="font-bold text-slate-900">{r.label}</span> <span className="text-xs text-slate-500 ml-2">{r.data.requests} demandes · {r.data.revenue.toFixed(2)} € · remplissage {r.data.fill_rate} %</span></div>
              {open === r.id ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </button>
            {open === r.id && <ReportBody data={r.data} />}
          </div>
        ))}
        {reports.length === 0 && <div className="text-sm text-slate-500">Aucun bilan clôturé pour le moment (le premier arrive au début du prochain trimestre).</div>}
      </div>
    </div>
  );
}
